import * as config from 'src/config';
import { SignInResult } from 'src/contexts/AwsCognitoContext';

export type ActionMap<M extends { [index: string]: any }> = {
  [Key in keyof M]: M[Key] extends undefined
    ? {
        type: Key;
      }
    : {
        type: Key;
        payload: M[Key];
      };
};

export type AuthUser = null | Record<string, any>;

export type AuthState = {
  isAuthenticated: boolean;
  isInitialized: boolean;
  user: AuthUser;
  // MFA対応 start --------------
  isRequiredMfa: boolean; // 対象ユーザーのMFA認証要否
  isMfaAuthenticated: boolean; // MFA認証済/未認証
  // MFA対応 end --------------
};

// MFA対応 start --------------
// MFA方式(Cognitoで選択可能な全MFA方式)
export const MFA_METHOD_TOTP: string = 'SOFTWARE_TOKEN_MFA';
export const MFA_METHOD_EMAIL: string = 'EMAIL_OTP';
export const MFA_METHOD_SMS: string = 'SMS_MFA';

// 当アプリで選択可能なMFA方法
export type AVAILABLE_MFA_METHODS = typeof MFA_METHOD_TOTP | typeof MFA_METHOD_EMAIL;

// ユーザーが直近で選択したMFA方式を保持するCognitoカスタム属性名
export const CUSTOM_ATTR_MFA_METHOD: string = 'custom:userSelectMfaMethod';

// TOTPデバイス登録用 Issuer
export const TOTP_AUTH_ISSUER = `MARS App ${config.currentEnv === 'production' ? '' : config.currentEnv}`;

export type AWSCognitoContextType = {
  isAuthenticated: boolean;
  isInitialized: boolean;
  user: AuthUser;
  isRequiredMfa: boolean | undefined; // ログインユーザーのMFA要否
  isMfaAuthenticated: boolean | undefined; // MFA認証済判定
  method: 'cognito';
  login: (email: string, password: string) => Promise<SignInResult>;
  register: (email: string, password: string, firstName: string, lastName: string) => Promise<unknown>;
  logout: () => Promise<void>;
  resetPassword: (email: string) => void;
  updateProfile: VoidFunction;
  loginFromAzure: (currentUser: AuthUser) => Promise<unknown>;
  newPassword: (email: string, code: string, password: string) => Promise<void>;
  updatePassword: (newPassword: string) => Promise<SignInResult>;
  verifySoftwareToken: (authCode: string) => Promise<void>;
  verifyMfaCode: (authCode: string) => Promise<void>;
  setUpSoftwareToken: () => Promise<URL | null>;
  updateMfaMethod: (method: AVAILABLE_MFA_METHODS) => Promise<void>;
  getRegisteredMfaMethod: () => Promise<AVAILABLE_MFA_METHODS | null>;
  moveToLoginWithClearStorage: () => void;
};
// MFA対応 end ----------------
